// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	LedgerReceiptsCustomButton: 'ledger-receipts-custom-button',
	AddReceiptButton: 'add-receipt-button',
	EditTitleButton: 'edit-title-button',
	EditDetailsButton: 'edit-details-button',
	EditButton: 'edit-button',
	RemoveButton: 'remove-button',
	GoToItemButton: 'go-to-item-button',
	SortButton: 'sort-button',
	AddANewLineButton: 'add-a-new-line-button',
	AddPaymentToClientButton: 'add-payment-to-client-button',
	GoToItemButton1: 'go-to-item-button-1',
	EditTitleButton1: 'edit-title-button-1',
	EditButton1: 'edit-button-1',
	RemoveButton1: 'remove-button-1',
	SortButton1: 'sort-button-1',
	DropdownOptions: 'dropdown-options',
	ShortfallAmountText: 'shortfall-amount-text',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
